<template>
  <v-btn
    color="success"
    small
    @click="downloadCSV"
  >
    Download CSV
  </v-btn>
</template>

<script>
import { mapState } from 'vuex';

import { downloadFileWithDisposition, CSV_FILE_TYPE, wrapToLoadingFn } from '@helpers';

import { LOCATIONS_NAMESPACE } from '@store/modules/locations.types';

import StatisticsApiService from '../_services/StatisticsApiService';

export default {
  name: 'DownloadCsv',

  props: {
    startDate: {
      type: String,
      required: true,
    },

    endDate: {
      type: String,
      required: true,
    },
  },

  computed: {
    ...mapState(LOCATIONS_NAMESPACE, ['suffix']),
  },

  methods: {
    downloadCSV() {
      this.wrapToLoadingFn({
        req: StatisticsApiService.downloadCSV.bind({}, {
          startDate: this.startDate,
          endDate: this.endDate,
          suffix: this.suffix,
        }),
        fullscreenLoadingSpinner: true,
        onSuccess: r => downloadFileWithDisposition({
          ...r,
          type: CSV_FILE_TYPE,
          defaultFileName: 'stat.csv',
        }),
      });
    },

    wrapToLoadingFn,
  },
};
</script>
